import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

export default class extends Controller {
  connect() {
  }

  refreshNewElementForm(event){ 
    let format = event.target.value
    let name = event.target.id.slice(0, -7)
    get(`/medidata_item_mappings/turbo/apply_element_format?element_format=${format}&element_name=${name}`, { responseKind: 'turbo-stream' }) 
  } 

  checkToAppendDictionaryElement(event){
    var target = event.target
    var targetName = target.getAttribute("name")
    var currentValue = parseInt(targetName.replace("][key]","").split("[")[4])
    var nextValue = currentValue + 1
    var newName = targetName.replace(currentValue, nextValue)
    if($(`input[name="${newName}"]`).length === 0){
      var newElement = document.createElement("tr")
      var elementName = targetName.split("[")[2].replace(/]/g, "")
      var template = `<tr><td>` +
      `<input type="text" class="form-control" name="${newName}" data-action="change->medidata-item-mapping-element#checkToAppendDictionaryElement"/>` +
      `</td><td>` +
      `<input type="text" class="form-control" name="medidata_item_mapping[elements][${elementName}][dictionary][${nextValue}][value]"/>` +
      `</td></tr>`

      target.parentNode.parentNode.insertAdjacentHTML('afterend', template)
    }
  }
} 
